export default __webpack_public_path__ + "static/media/2m.0d34391c.svg";